import { render, staticRenderFns } from "./AboutHome.vue?vue&type=template&id=13b1bc76&"
import script from "./AboutHome.vue?vue&type=script&lang=js&"
export * from "./AboutHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports